import { IMatchingGift } from '../../../commons';
import { MatchingGiftActions, MatchingGiftActionTypes } from './matching-gift.actions';

export interface State {
    error: string | null;
    pending: boolean;
    success: string | null;
    stateData: IMatchingGift | null;
}

export const initialState: State = {
    error: null,
    success: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: MatchingGiftActions): State {
    switch (action.type) {

        case MatchingGiftActionTypes.LoadMatchingGiftState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case MatchingGiftActionTypes.LoadMatchingGiftStateSuccess: {
            return {
                ...state,
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case MatchingGiftActionTypes.LoadMatchingGiftStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }
        case MatchingGiftActionTypes.IUDMatchingGiftState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case MatchingGiftActionTypes.IUDMatchingGiftStateSuccess: {
            return {
                ...state,
                error: null,
                success: action.statusId === 1? 'Successfully submitted!': 'Successfully saved!',
                pending: false
            };
        }

        case MatchingGiftActionTypes.arwMatchingGift: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case MatchingGiftActionTypes.arwMatchingGiftSuccess: {
            return {
                ...state,
                error: null,
                success: action.msg,
                pending: false
            };
        }
        case MatchingGiftActionTypes.MatchingGiftScreenErrorReset: {
            // return state;
            return {
                ...state,
                error: null,
                success: null,
                pending: false
            };
        } 
        case MatchingGiftActionTypes.LoadInitialState: {
            return state = initialState;
           
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getSuccess = (state: State) => state.success;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;